export const SPECIAL_REQUEST_LIST = 'SPECIAL_REQUEST_LIST';
export const SPECIAL_REQUEST_GETALL = 'SPECIAL_REQUEST_GETALL';
export const SPECIAL_REQUEST_DETAIL = 'SPECIAL_REQUEST_DETAIL';

export default {
    SPECIAL_REQUEST_LIST,
    SPECIAL_REQUEST_GETALL,
    SPECIAL_REQUEST_DETAIL
};
